import { render, staticRenderFns } from "./OrdenesServicio.vue?vue&type=template&id=338a9826"
import script from "./OrdenesServicio.vue?vue&type=script&lang=js"
export * from "./OrdenesServicio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports